
import ManagerAnalytics from "../insights/ManagerAnalytics";

export { Page }

function Page() {
  return <ManagerAnalytics />;
}
